import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { format } from 'date-fns'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'ts-debounce'

import { datatableSelectors } from './store'

import { dateHelpers } from '@/helper'

const DEBOUNCE_DELAY = 600

type Props = {
	onChange: (value: any) => void
	dataKey: string
}

const DatatableDatepickerFilter = ({ dataKey, onChange }: Props) => {
	const [value, setValue] = useState<Date | null>(null)
	const debounceChangeDate = useRef(
		debounce((v: string) => {
			onChange(v)
		}, DEBOUNCE_DELAY),
	).current
	const filter = useSelector(datatableSelectors.getFilter(dataKey))

	useEffect(() => {
		const filterValue = filter.value as string
		if (filterValue && dateHelpers.isDateValid(new Date(filterValue))) {
			setValue(new Date(filterValue))
		} else {
			setValue(null)
		}
	}, [filter.value])

	const handleChangeDate = (date: Date | null) => {
		setValue(date)
		if (date && dateHelpers.isDateValid(date)) {
			debounceChangeDate(format(date, 'yyyy-MM-dd'))
		} else {
			debounceChangeDate('')
		}
	}

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DatePicker
				value={value}
				onChange={handleChangeDate}
				minDate={new Date('2000-01-01')}
				format="yyyy-MM-dd"
				slotProps={{
					textField: {
						fullWidth: true,
					},
					actionBar: {
						actions: ['clear'],
					},
				}}
			/>
		</LocalizationProvider>
	)
}

export default DatatableDatepickerFilter
